import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import "react";
import { Grid } from "@vk-hr-tek/ui/Grid";
import { Button } from "@vk-hr-tek/ui/Button";
import { Icon } from "@vk-hr-tek/ui/Icon";
import { TreeViewAutocomplete } from "../../TreeViewAutocomplete/index.js";
const UnitsInput = (t0)=>{
    const $ = c(25);
    const { index, name, label, placeholder, tooltip, options, disabled: t1, onChange, onLoadTree, onChildrenLoad, onSearch, config } = t0;
    const disabled = void 0 === t1 ? false : t1;
    const { firstField, lastField, onAdd, onDelete } = config;
    const t2 = 0 === index ? label : void 0;
    const t3 = placeholder || label;
    const t4 = 0 === index ? tooltip : void 0;
    let t5;
    if ($[0] !== index || $[1] !== onChange) {
        t5 = null == onChange ? void 0 : onChange(index);
        $[0] = index;
        $[1] = onChange;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== disabled || $[4] !== name || $[5] !== onChildrenLoad || $[6] !== onLoadTree || $[7] !== onSearch || $[8] !== options || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
        t6 = /*#__PURE__*/ jsx(Grid, {
            item: true,
            xs: 12,
            md: 6,
            children: /*#__PURE__*/ jsx(TreeViewAutocomplete, {
                withoutMargins: true,
                clearable: true,
                name: name,
                label: t2,
                placeholder: t3,
                tooltip: t4,
                options: options,
                disabled: disabled,
                onChange: t5,
                onLoadTree: onLoadTree,
                onChildrenLoad: onChildrenLoad,
                onSearch: onSearch
            })
        });
        $[3] = disabled;
        $[4] = name;
        $[5] = onChildrenLoad;
        $[6] = onLoadTree;
        $[7] = onSearch;
        $[8] = options;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = firstField ? "24" : "0";
    const t8 = firstField ? "4" : "0";
    let t9;
    if ($[14] !== lastField || $[15] !== onAdd || $[16] !== onDelete) {
        t9 = lastField ? /*#__PURE__*/ jsx(Button, {
            icon: /*#__PURE__*/ jsx(Icon, {
                name: "add",
                size: "24"
            }),
            onClick: onAdd,
            size: "large"
        }) : /*#__PURE__*/ jsx(Button, {
            variant: "tertiaryLight",
            icon: /*#__PURE__*/ jsx(Icon, {
                name: "delete_outline",
                size: "24",
                color: "original.brand.primary"
            }),
            size: "large",
            onClick: onDelete
        });
        $[14] = lastField;
        $[15] = onAdd;
        $[16] = onDelete;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
        t10 = /*#__PURE__*/ jsx(Grid, {
            item: true,
            display: "flex",
            flexDirection: "column-reverse",
            mt: t7,
            pt: t8,
            children: t9
        });
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t6) {
        t11 = /*#__PURE__*/ jsxs(Grid, {
            container: true,
            direction: "row",
            spacing: "20",
            wrap: "nowrap",
            children: [
                t6,
                t10
            ]
        });
        $[22] = t10;
        $[23] = t6;
        $[24] = t11;
    } else t11 = $[24];
    return t11;
};
export { UnitsInput };
